import {
  SET_CONVERSATION,
  SET_CONVERSATION_PREVIEW,
  UPDATE_PREVIEW,
  READ_PREVIEW,
  READ_MESSAGE,
  ADD_TO_CONVERSATION
} from "@/constants/action-conversation-types";

import type { IMessage, IConversation, IConversationPreview } from "@/types";

interface UpdatePreviewPayload {
  conversation: {
    conversation_id: string;
    message: IMessage;
  };
  read: boolean;
}

// Action creators
export const setConversation = (conversations: IConversation[]) => ({
  type: SET_CONVERSATION, 
  payload: conversations
} as const);

export const addToConversation = (conversations: Array<{ conversation_id: string; message: IMessage }>) => ({
  type: ADD_TO_CONVERSATION, 
  payload: conversations
} as const);

export const setConversationPreview = (previews: IConversationPreview[]) => ({
  type: SET_CONVERSATION_PREVIEW, 
  payload: previews
} as const);

export const updatePreview = (conversation: UpdatePreviewPayload['conversation'], read: boolean) => ({
  type: UPDATE_PREVIEW, 
  payload: { conversation, read }
} as const);

export const readPreview = (conversation: string) => ({
  type: READ_PREVIEW, 
  payload: conversation
} as const);

export const readMessage = (conv_id: string, user_id: string) => ({
  type: READ_MESSAGE, 
  payload: { conv_id, user_id }
} as const);